<template>
    <div class="hoger-lager-wrapper">
        <v-confetti ref="confettiComp"></v-confetti>

        <h2 class="encouragement" ref="encouragement" v-html="copyLine">.</h2>

        <div class="hoger-lager">

            <div class="arrow" ref="upArrow" @click="onAnswer('hoger')" @mouseover="onMouseOverArrow" @mouseout="onMouseOutArrow">
                <img src="/static/img/hoger.png" />
            </div>

            <div class="max-width-row">
                <div class="ball-container" :class="{ 'has-padding': !answerGiven }" ref="ballContainer">

                    <v-ball ref="ballRef" v-for="n in ballArray.length" :key="'ball-' + n" :number="ballArray[n - 1]"></v-ball>

                    <div class="question-ball">
                        <span>?</span>
                    </div>

                </div>
            </div>

            <!-- <div class="grass"></div> -->

            <div class="arrow bottom" ref="downArrow" @click="onAnswer('lager')" @mouseover="onMouseOverArrow" @mouseout="onMouseOutArrow">
                <img src="/static/img/lager.png" />
            </div>

        </div>

        <span class="pre-prize">Je {{ 'speelt voor' }}:</span><br/>
        <span class="prize">{{ prizeList[ prizeNum - 1 ] }}</span>
        <!-- <span class="prize">Kans op <span v-if="prizeNum <= 6">{{ prizeNum * 10 }} loten</span><span v-else><br/>de hoofdprijs van 100 loten!</span></span> -->
    </div>
</template>

<style lang="scss" scoped>
    .max-width-row{
        pointer-events:none;
    }

    span.prize:first-letter{
        text-transform:uppercase;
    }
</style>

<script>
    import LottoBall from '@/app/components/Ball';
    import Confetti from '@/app/components/Confetti';
    import { TimelineMax, TweenMax } from '@/vendor';
    import Vue from 'vue';

    export default {
        components: {
            'v-ball': LottoBall,
            'v-confetti': Confetti
        },

        data()
        {
            return {
                answerGiven: false,
                ballArray: [],

                confettiTimeline: null,
                wrongAnswerTimeline: null,
                easing: Strong.easeOut,

                copyLine: 'Wat denk jij, is de volgende bal hoger of lager? <br/><span class="small">(Tip: Lotto heeft 45 ballen)</span>',
                prizeNum: 1,

                correctCopy: [
                    'Yeah! Wat goed!<br/>Of is het beginnersgeluk?',
                    'Wow! Je hebt de 2e ook goed!',
                    'Woohooo! Dit is vast jouw geluksdag!',
                    'Wat een natuurtalent! Ga zo door!',
                    'Jaaaaa! Nog 1 goed raden en je<br/>maakt kans op de hoofdprijs van €4.500!',
                    'En de laatste is ook goed! Geweldig!'
                ],
                gameoverCopy: [
                    'Helaas, fout gegokt!<br/>Probeer het snel nog een keer!',
                    'Helaas, het was hoger.<br/>Je maakt kans op -n- loten!'
                ],
                // prizeList: [
                //     'kans op €500',
                //     'kans op €500 en €1000',
                //     'kans op €500, €1000 en €2000',
                //     'kans op €500, €1000, €2000 en €3000',
                //     'kans op €500, €1000, €2000, €3000 en €4000',
                //     'kans op €500, €1000, €2000, €3000, €4000 en €4500'
                // ]
                prizeList: [
                    'kans op €500',
                    'kans op €1.000',
                    'kans op €2.000',
                    'kans op €3.000',
                    'kans op €4.000',
                    'kans op €4.500'
                ]
            };
        },

        computed: {
            isDebug()
            {
                return this.$store.getters['getDebug'];
            },

            numGuesses()
            {
                return this.$store.getters['getAnswers'].length;
            },

            questionNum()
            {
                return Math.min( 6, this.ballArray.length - 1 );
            },

            correctAnswers()
            {
                return Math.min( 5, this.$store.getters['getCorrectAnswers'].length );
            }
        },

        created()
        {
            /*
            var highest = 0;
            var lowest = 5;

            for( var i = 0; i < 1000; i++ )
            {
            */

            let num = Math.floor( Math.random() * 16 ) + 1;
            if( num > 9 )
            {
                num += 27;
            }

            this.ballArray.push( num + 1 );

            /*
            if( num >= highest )
            {
                highest = num;
            }

            if( num <= lowest )
            {
                lowest = num;
            }
            }
            console.log( lowest, highest );
            */
        },

        mounted()
        {
            TweenMax.set( [ '.hoger-lager-wrapper', '.encouragement' ], { opacity: 0 });

            this.confettiTimeline = new TimelineMax();
            this.confettiTimeline.to( '.question-ball span', 0.5, { y: '+=0.1' });

            this.wrongAnswerTimeline = new TimelineMax();
            this.wrongAnswerTimeline.to( '.question-ball span', 0.5, { y: '+=0.1' });
        },

        methods: {
            onAnswer( pAnswer )
            {
                if( this.answerGiven === true )
                {
                    return;
                }

                this.answerGiven = true;
                let correct = null;

                // dispatch answer correct true/false
                let newBallNum = this.generateBall();

                if( this.isDebug )
                {
                    if( pAnswer === 'hoger' )
                    {
                        correct = true;
                    }
                    else
                    {
                        correct = false;
                    }
                }
                else
                {
                    if( ( newBallNum > this.ballArray[ this.numGuesses ] && pAnswer === 'hoger' ) ||
                        ( newBallNum < this.ballArray[ this.numGuesses ] && pAnswer === 'lager' ) )
                    {
                        correct = true;
                    }
                    else
                    {
                        correct = false;
                    }
                }

                this.$store.dispatch( 'answerGiven', { correct: correct, ball: newBallNum });

                // determine copy
                if( correct === true )
                {
                    this.copyLine = this.correctCopy[ this.questionNum ];
                }
                else
                {
                    if( this.questionNum === 0 )
                    {
                        this.copyLine = this.gameoverCopy[ 0 ];
                    }
                    else if( pAnswer === 'hoger' )
                    {
                        this.copyLine = `Gefeliciteerd! <br/>Je maakt ${this.prizeList[ this.prizeNum - 2 ]}!`;
                    }
                    else
                    {
                        this.copyLine = `Gefeliciteerd! <br/>Je maakt ${this.prizeList[ this.prizeNum - 2 ]}!`;
                    }
                }

                // increase guessNum & handle new Ball
                if( this.numGuesses < 7 )
                {
                    this.ballArray.push( newBallNum );
                }

                // anim new Ball
                Vue.nextTick( () =>
                {
                    this.animBall( correct, pAnswer );
                });
            },

            animBall( pCorrect, pAnswer )
            {
                let tl = new TimelineMax({
                    align: 'normal',
                    onComplete: () =>
                    {
                        if( this.numGuesses < 6 && pCorrect )
                        {
                            this.answerGiven = false;
                        }
                        else if( this.numGuesses === 1 && !pCorrect )
                        {
                            this.triggerQuickReplay();
                        }
                        else
                        {
                            this.$router.replace( '/gegevens' );
                        }
                    }
                });

                tl.addLabel( 'start', 0 );
                tl.addLabel( 'roll-in', 'start+=0.5' );
                tl.addLabel( 'confetti', 'roll-in+=1' );
                tl.addLabel( 'shove', 'confetti+=1.5' );

                tl.to( '.question-ball', 0.3, { opacity: 0 }, 'start' );

                // arrows split
                tl.to( this.$refs.upArrow, 0.5, { y: '-=75%', scale: pAnswer === 'hoger' ? 1.05 : 0.6, opacity: pAnswer === 'lager' ? 0.3 : 1, ease: Circ.easeOut }, 'start' );
                tl.to( this.$refs.downArrow, 0.5, { y: '+=75%', scale: pAnswer === 'lager' ? 1.05 : 0.6, opacity: pAnswer === 'hoger' ? 0.3 : 1, ease: Circ.easeOut }, 'start' );

                // roll anim
                tl.fromTo( this.$refs.ballRef[ this.numGuesses ].animIn(), 1.5, { progress: 0 }, { progress: 1, ease: this.easing }, 'roll-in' );

                if( pCorrect )
                {
                    tl.add( () =>
                    {
                        this.$refs.confettiComp.spawnConfetti( this.questionNum * 50 );
                    }, 'confetti' );

                    tl.fromTo( this.$refs.encouragement, 0.5, { opacity: 0, scale: 0, rotation: Math.random() * 20 - 10 }, { opacity: 1, scale: 1, rotation: 0, ease: Back.easeOut.config( 3 ) }, 'confetti+=0.1' );
                }
                else
                {
                    tl.fromTo( this.$refs.encouragement, 0.5, { opacity: 0, y: 50, rotation: Math.random() * 10 - 5 }, { opacity: 1, y: 0, rotation: 0, ease: Back.easeOut.config( 2 ) }, 'confetti+=0.1' );
                }

                if( this.numGuesses < 6 && pCorrect )
                {
                    // shove
                    tl.fromTo( this.$refs.ballContainer, 0.3, { 'padding-right': '0vh' }, { 'padding-right': '+=17.69vh' }, 'shove' ); // 16.94vh + 0.75vh

                    tl.to( this.$refs.upArrow, 0.3, { y: '+=75%', scale: 1, opacity: 1, ease: Circ.easeOut }, 'shove+=0.2' );
                    tl.to( this.$refs.downArrow, 0.3, { y: '-=75%', scale: 1, opacity: 1, ease: Circ.easeOut }, 'shove+=0.2' );

                    tl.to( '.question-ball', 0.3, { opacity: 0.5 }, 'shove+=0.2' );

                    tl.add( () =>
                    {
                        this.prizeNum = this.correctAnswers + 1;
                    }, 'shove+=0.2' );
                }
                else if( pCorrect )
                {
                    TweenMax.set( this.$refs.ballContainer, { 'padding-right': '0vh' }, 'shove' );

                    tl.add( () =>
                    {
                        this.$refs.confettiComp.spawnConfetti( this.questionNum * 50 );
                    }, '+=1' );

                    tl.add( () =>
                    {
                        this.$refs.confettiComp.spawnConfetti( this.questionNum * 50 );
                    }, '+=2' );

                    tl.add( function() {}, '+=0.5' ); // force 1.5s extra
                }
                else
                {
                    TweenMax.set( this.$refs.ballContainer, { 'padding-right': '0vh' }, 'shove' );
                    tl.add( function() {}, '+=1.5' ); // force 1.5s extra
                }
            },

            generateBall()
            {
                let num = Math.floor( Math.random() * 45 ) + 1;

                if( this.ballArray.indexOf( num ) !== -1 )
                {
                    return this.generateBall();
                }
                else
                {
                    return num;
                }
            },

            onMouseOverArrow( e )
            {
                if( this.answerGiven )
                {
                    return;
                }

                if( e.target.classList.contains( 'bottom' ) )
                {
                    TweenMax.to( e.target, 0.15, { y: '15', scale: 1.05 });
                    return;
                }

                TweenMax.to( e.target, 0.15, { y: '-15', scale: 1.05 });
            },

            onMouseOutArrow( e )
            {
                TweenMax.to( e.target, 0.15, { y: '0', scale: 1 });
            },

            triggerQuickReplay()
            {
                let resetTl = new TimelineMax();

                resetTl.to( this.$refs.ballRef[ 1 ].$el, 0.3, { opacity: 0 }, 0 );
                resetTl.add( () =>
                {
                    let firstBall = this.ballArray[0];
                    this.ballArray = [ firstBall ];
                    this.$store.dispatch( 'resetGame' );
                    this.answerGiven = false;
                }, 0.3 );

                resetTl.set( this.$refs.ballContainer, { 'padding-right': '17.69vh' }, 0.3 );

                resetTl.to( this.$refs.upArrow, 0.3, { y: '+=75%', scale: 1, opacity: 1, ease: Sine.easeOut }, 0.4 );
                resetTl.to( this.$refs.downArrow, 0.3, { y: '-=75%', scale: 1, opacity: 1, ease: Sine.easeOut }, 0.4 );

                resetTl.to( '.question-ball', 0.3, { opacity: 0.5 }, 0.4 );
            },

            getAnimateIn()
            {
                TweenMax.set( this.$refs.upArrow, { transformOrigin: '50% 100%' });
                TweenMax.set( this.$refs.downArrow, { transformOrigin: '50% 0%' });

                let tl = new TimelineMax();

                tl.to( '.hoger-lager-wrapper', 0.15, { opacity: 1 }, 0 );

                tl.fromTo( this.$refs.ballRef[0].animIn(), 1.5, { progress: 0 }, { progress: 1, ease: this.easing }, 0 );
                tl.from( [ this.$refs.upArrow, this.$refs.downArrow ], 0.3, { opacity: 0, scale: 0, rotation: 10, ease: Back.easeOut.config( 3 ) }, 1 );
                tl.to( '.encouragement', 0.3, { opacity: 1 }, 1 );

                tl.to( this.$refs.upArrow, 0.1, { y: '+=75%' }, 0 );
                tl.to( this.$refs.downArrow, 0.1, { y: '-=75%' }, 0 );

                tl.from( '.pre-prize', 0.3, { y: '+=20', opacity: 0 }, 2 );
                tl.from( '.prize', 0.3, { y: '+=30', opacity: 0 }, 2 );

                return tl;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/components/HogerLager.vue